import { motion } from 'framer-motion'
import { CanvasEmptyIllustration } from './components/CanvasEmptyIllustration'
import {
  EMPTY_STATE_HEIGHT,
  EMPTY_STATE_POSITION,
  EMPTY_STATE_WIDTH,
} from './consts'

export const CanvasOnboarding = () => (
  <motion.div
    className="pointer-events-none absolute"
    style={{
      width: EMPTY_STATE_WIDTH,
      height: EMPTY_STATE_HEIGHT,
      left: EMPTY_STATE_POSITION.x,
      top: EMPTY_STATE_POSITION.y,
      zIndex: 50,
    }}
    initial={{ opacity: 0, scale: 0.94 }}
    animate={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.6, ease: 'easeOut' }}
  >
    <div className="relative h-full w-full">
      <motion.div
        className="absolute left-1/2 top-1/2 h-56 w-56 -translate-x-1/2 -translate-y-1/2 rounded-full bg-gradient-to-br from-violet-200/50 via-sky-100/40 to-fuchsia-100/30 blur-3xl"
        animate={{ scale: [1, 1.06, 1], opacity: [0.55, 0.75, 0.55] }}
        transition={{ duration: 5, repeat: Infinity, ease: 'easeInOut' }}
        aria-hidden
      />
      <motion.div
        className="absolute left-[18%] top-[8%] h-20 w-20 rounded-full bg-violet-300/25 blur-2xl"
        animate={{ y: [0, -8, 0], x: [0, 4, 0] }}
        transition={{ duration: 4.5, repeat: Infinity, ease: 'easeInOut' }}
        aria-hidden
      />
      <motion.div
        className="absolute bottom-[10%] right-[12%] h-16 w-16 rounded-full bg-sky-300/20 blur-2xl"
        animate={{ y: [0, 6, 0], x: [0, -3, 0] }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 0.8,
        }}
        aria-hidden
      />

      <div className="relative flex h-full w-full items-center justify-center px-4">
        <CanvasEmptyIllustration />
      </div>
    </div>
  </motion.div>
)
